/**
 * @module FE-CU06_パスワード初期化画面_パスワード再登録
 */
import Header from '../../components/header/Header.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

const passwordValidationRegExp =
  /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*?[!-/:-@[-`{-~])|(?=.*[A-Z])(?=.*[0-9])(?=.*?[!-/:-@[-`{-~])|(?=.*[a-z])(?=.*[0-9])(?=.*?[!-/:-@[-`{-~]))([!-~]){8,}$/;
const PAGE_ID = 'FE-CU06';

export default {
  name: 'PasswordInitReregistration',
  components: {
    Header,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      pcTitle: vm.$vuetify.lang.t(
        '$vuetify.FECU06パスワード初期化画面パスワード再登録.パスワード再登録'
      ),
      spTitle: vm.$vuetify.lang.t(
        '$vuetify.FECU06パスワード初期化画面パスワード再登録.パスワード再登録'
      ),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.C0001'
      ),
      password: '',
      confirmPassword: '',
      passwordError: '',
      confirmPasswordError: '',
      showPassword: false,
      showConfirmPassword: false,
      valid: false,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    passwordRules() {
      // require
      // FE-CU6-E0001
      // "新パスワードは必ず入力してください。",
      if (this.password === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.E0001'
          ),
        ];
      }
      // min
      // FE-CU6-E0011
      // "パスワードは8文字以上入力ください。"
      if (this.password.length < 8) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.E0011'
          ),
        ];
      }

      // validation
      // FE-CU6-E0008
      // "新パスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上使用してください。"
      if (passwordValidationRegExp.test(this.password)) {
        return [true];
      } else {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.E0008'
          ),
        ];
      }
    },
    confirmPasswordRules() {
      // require
      // FE-CU6-E0003
      // "確認用パスワードは必ず入力してください。",
      if (this.confirmPassword === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.E0003'
          ),
        ];
      }
      // confirmation
      // FE-CU6-E0005
      // "新パスワードと確認用パスワードが一致しません。",
      if (this.confirmPassword !== this.password) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.E0005'
          ),
        ];
      }
      // min
      // FE-CU6-E0011
      // "パスワードは8文字以上入力ください。",
      if (this.confirmPassword.length < 8) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.E0011'
          ),
        ];
      }
      // validation
      // FE-CU6-E0010
      // "確認用パスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上使用してください。",
      if (!passwordValidationRegExp.test(this.confirmPassword)) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.E0010'
          ),
        ];
      }
    },

    i18nItems(vm) {
      return {
        pcTitle: vm.$vuetify.lang.t(
          '$vuetify.FECU06パスワード初期化画面パスワード再登録.パスワード再登録'
        ),
        spTitle: vm.$vuetify.lang.t(
          '$vuetify.FECU06パスワード初期化画面パスワード再登録.パスワード再登録'
        ),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.C0001'
        ),
      };
    },
    isValid() {
      return this.checkValid();
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 再登録ボタン活性制御判定
     */
    checkValid() {
      if (this.password !== '' && this.confirmPassword !== '' && this.valid) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 確認ダイアログ
     */
    async openAgreementDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );

      if (result) {
        this.APP_CU0601();
      }
    },
    /**
     * APP_CU0601 パスワード更新
     */
    APP_CU0601: async function () {
      this.$_setLoading(true);

      let param = '/api/passwordInitReregistration/passwordUpdate'; // 本番用
      // let param = "post"; // 検証用
      // let param = "status/400";

      let queries = {
        oneTimeUrlId: this.$route.params.oneTimeUrlID,
        secretAnswer: this.$store.state.answer,
        password: this.password,
        modified: this.$store.state.modifiedForNewPassword,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     passwordChangeResult: 0,
            //   },
            // };

            if (apiData.contentsInfo.updatePasswordResult == 0) {
              // Thanks画面に遷移しパスワード初期化受付完了のメッセージを表示する。
              this.$store.commit('setThanksType', {
                fromPageInfo: { page: 6 },
                displayType: 2,
              });
              this.$router.replace({ path: '/thanks' });
            } else {
              // Thanks画面に遷移し失効したワンタイムURLのメッセージを表示する。
              this.$store.commit('setThanksType', {
                fromPageInfo: { page: 0 },
                displayType: 5,
              });
              this.$router.replace({ path: '/thanks' });
            }
          },
          (error) => {
            if (error.response.status == 400) {
              this.confirmDialog = false;
              // エラーダイアログを表示する。
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.E0006'
              );
            } else if (error.response.status == 409) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU06パスワード初期化画面パスワード再登録.E0012'
              );
            } else {
              // 異常系の処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
  },
  mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.$_pvCount(PAGE_ID);
    //初期通信完了後に画面を表示
    this.isShowPage = true;
  },
};
